import React from 'react'
import { Grid } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';

const CpnClassifyIssue = (props) => {
    const { 
        form, 
        Option,
        setsTypeClassifyIssue,
        setIsRequireOtherInprogress,
        setIsRequireObjInprogress,
        setIsOtherRequest,
    } = props;

    const onHandleJobType =(eventValue)=>{
        setIsRequireObjInprogress(false)
        setIsRequireOtherInprogress(false)
        setIsOtherRequest(false)
        form.clearErrors("oTypeRequest")
        form.clearErrors("sRequestTypeOther")
        form.clearErrors("oTypeResolve")
        form.clearErrors("oReqInprogress")
        form.clearErrors("sReqInprogress")
        form.clearErrors("oTypeCompliant")
        if(eventValue)
        {
            form.setValue("sTypeResponPerson", "22")
            form.setValue("sResponPerson", "25")

            // form.setValue("oUnitExternalPTT", null)
            // form.setValue("oAutoUnitInGBU", null)
            // form.setValue("oAutoEmpInGBU", null)
            // form.setValue("oAutoUnitInPTT", null)
            // form.setValue("oAutoEmpInPTT", null)

            if(eventValue.value === "1")  //ร้องเรียน
            {
                setsTypeClassifyIssue("C")
                form.setValue("oTypeResolve", { label: "ข้อร้องเรียนปกติ", value: "4" })
                form.setValue("oTypeCompliant", { label: "Operation", value: "7" })

                form.setValue("oTypeRequest", null)
            }
            else if(eventValue.value === "2")   //ร้องขอ
            {
                setsTypeClassifyIssue("R")
                form.setValue("oTypeResolve", null)
                form.setValue("oTypeCompliant", null)
                form.setValue("oReqInprogress", null)
                form.setValue("sReqInprogress", null)
            }
        }
        else    //ลบข้อมูลของประเภทให้หมด
        {
            form.setValue("oTypeResolve", null)
            form.setValue("oTypeCompliant", null)
            form.setValue("oTypeRequest", null)

            // form.setValue("oUnitExternalPTT", null)
            // form.setValue("oAutoUnitInGBU", null)
            // form.setValue("oAutoEmpInGBU", null)
            // form.setValue("oAutoUnitInPTT", null)
            // form.setValue("oAutoEmpInPTT", null)
        }
    }

    return (
        <>
            <Accordion header={"จำแนกประเภทการแจ้งปัญหา (ข้อมูลใช้ภายใน)"}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oTypeJobType"
                            label="ประเภทการแจ้งปัญหา"
                            required={true}
                            options={Option.lstJobType ?? []}
                            onChange={(eventValue)=>{ onHandleJobType(eventValue)}}
                        />
                    </Grid>
                </Grid>
            </Accordion>
        </>
    )
}

export default CpnClassifyIssue